import { render, staticRenderFns } from "./catalog-list.vue?vue&type=template&id=50df28b8"
import script from "./catalog-list.vue?vue&type=script&lang=js"
export * from "./catalog-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports